import {ReactElement} from 'react'
import {Button} from '@material-ui/core'
import {Trans} from 'react-i18next'
import {useHistory} from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'

import {ModalContainer} from '../ModalContainer'
import messages from '../../../../../assets/messages'
import {useReadRejectedMessage} from './hooks'
import {useStyles} from './styles'

const none = () => null

const SUPPORT_EMAIL = 'support@tauromarkets.com'

type DepositMethodVerificationRejectedModalProps = {
  issueRejectedNoReadId: number | null
}

function DepositMethodVerificationRejectedModal(props: DepositMethodVerificationRejectedModalProps): ReactElement {
  const {issueRejectedNoReadId} = props
  const {readRejectedDepositMethodIssueMessage, submitting} = useReadRejectedMessage()
  const classes = useStyles()
  const history = useHistory()

  const handleGoToAccountsClick = async () => {
    try {
      await readRejectedDepositMethodIssueMessage(issueRejectedNoReadId)
    } catch (e) {
      console.error(e)
    } finally {
      history.push('/')
    }
  }

  return (
    <ModalContainer isOpen onClose={none}>
      <div className={classes.content}>
        <div className={classes.header}>
          <div className={classes.title}>
            <Trans {...messages.depositMethodVerificationRejected} />
          </div>
        </div>
        <div className={classes.body}>
          <div className={classes.text}>
            <Trans {...messages.yourDepositMethodVerificationWasRejected} />
          </div>
          <div className={classes.text}>
            <Trans
              {...messages.ifYouHaveUrgentQuestions}
              values={{supportEmail: SUPPORT_EMAIL}}
              components={[<a className={classes.link} href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>]}
            />
          </div>
          <Button
            fullWidth
            disabled={submitting}
            className={classes.button}
            color='primary'
            variant='contained'
            onClick={handleGoToAccountsClick}
          >
            {submitting ? <CircularProgress className={classes.loader} size={12} /> : null}
            <Trans {...messages.goBackToAccounts} />
          </Button>
        </div>
      </div>
    </ModalContainer>
  )
}

export {DepositMethodVerificationRejectedModal}
